import { useQuery } from '@tanstack/react-query'
import { mk2SettlingKey } from './mk2ImportSettle'

/**
 * Whether an MK2 import into this interface is still waiting for its decoders
 * (see `mk2ImportSettle.ts`). Only ever written with `setQueryData`; it never
 * fetches.
 */
const useMk2ImportSettling = (interfaceId: number): boolean => {
  const { data } = useQuery(mk2SettlingKey(interfaceId), () => false, {
    enabled: false,
    initialData: false,
    staleTime: Infinity,
  })
  return Boolean(data)
}

export default useMk2ImportSettling
